import { cloneDeep, isEmpty, union, isNil } from 'lodash';

import { loading, success, error } from 'State/actions';
import getDatabase from 'Common/DB';
import { getDatabaseName, getOnline } from 'State/selectors';
import * as types from 'PointOfSale/modules/mealTypes/state/types';
import { getServingDetails, getServedItemsOrder } from 'PointOfSale/selectors';
import { parseServedItemOrder } from 'PointOfSale/modules/common/helpers';

export const selectMealType = label => ({
  type: types.SELECT_POS_MEAL_TYPES,
  payload: {
    label,
    subMenuTab: 'All Food Items',
  },
});

export const selectTabMenu = tab => ({
  type: types.SELECT_POS_MEAL_TYPES_SUBMENU,
  payload: tab.key,
});

export const setSearchText = searchText => ({
  type: types.SET_SEARCH_TEXT,
  payload: searchText,
});

export const selectFoodItem = (item, selected) => ({
  type: types.TOGGLE_SERVED_ITEM_SELECTION,
  payload: { item, selected },
});

export const reset = () => (dispatch, getState) => {
  const state = getState();
  const foodItems = cloneDeep(state.PointOfSaleState.mealTypes.foodItems);
  const currentSelectedMenu =
    state.PointOfSaleState.mealTypes.currentSelectedMenu;
  const currentSelectedTabMenu =
    state.PointOfSaleState.mealTypes.currentSelectedTabMenu;
  const activeSession = cloneDeep(
    state.PointOfSaleState.servingOptions.activeSession
  );

  const session = cloneDeep(state.PointOfSaleState.servingOptions.sessions);
  const quickServeFoodItem = session[activeSession]
    ? session[activeSession].quickServeItem
    : null;

  if (
    currentSelectedTabMenu === 'All Food Items' ||
    currentSelectedTabMenu === 'Uncategorized'
  ) {
    const tabMenus = Object.keys(foodItems[currentSelectedMenu]);
    const foodItemsUnion = [];
    tabMenus.map(tab => {
      return foodItemsUnion.push(foodItems[currentSelectedMenu][tab]);
    });

    const allItems = union(...foodItemsUnion);

    foodItems[currentSelectedMenu][currentSelectedTabMenu] =
      currentSelectedTabMenu === 'All Food Items'
        ? allItems
        : allItems.filter(f => f.ItemCategoryId === null);

    if (!isEmpty(quickServeFoodItem)) {
      foodItems[currentSelectedMenu][currentSelectedTabMenu].map(foodItem => {
        if (foodItem.ItemId !== quickServeFoodItem.ItemId) {
          foodItem.selected = false;
        }
        return foodItem;
      });
    } else {
      foodItems[currentSelectedMenu][currentSelectedTabMenu].map(foodItem => {
        return (foodItem.selected = false);
      });
    }
  } else {
    if (!isEmpty(quickServeFoodItem)) {
      foodItems[currentSelectedMenu][currentSelectedTabMenu].map(foodItem => {
        if (
          foodItem.ItemId !== quickServeFoodItem.ItemId &&
          foodItem.selected
        ) {
          foodItem.selected = false;
        }
        return foodItem;
      });
    } else {
      foodItems[currentSelectedMenu][currentSelectedTabMenu].map(foodItem => {
        if (foodItem.selected) {
          foodItem.selected = false;
        }
        return foodItem;
      });
    }
  }
  dispatch({
    type: types.UPDATE_SERVED_ITEMS,
    payload: foodItems,
  });
};

export const saveOrderNum = () => async (dispatch, getState, MPWAPI) => {
  try {
    const state = getState();

    const databaseName = getDatabaseName(state);
    const DB = await getDatabase(databaseName);

    const isOnline = getOnline(state);
    dispatch(loading(types.SAVE_ORDER_NUM_ERROR, null));
    dispatch(loading(types.SAVE_ORDER_NUM_SUCCESS, false));
    const servedItemsOrder = getServedItemsOrder(state);
    const { PrimarySiteId } = getServingDetails(state);

    const ServedItemUserModels = parseServedItemOrder(servedItemsOrder);
    const model = {
      SiteId: PrimarySiteId,
      ServedItemUserModels,
    };

    if (isOnline) {
      dispatch(loading(types.SAVE_ORDER_NUM_FETCHING, true));
      await MPWAPI.postGenericInsertUpdate(
        'ServedItem/WriteServedItemOrder',
        model
      );
    }
    const servedItems = await DB.ServedItems.where({
      SiteId: PrimarySiteId,
    }).toArray();

    const updatedLocalServedItems = servedItems.map(si => {
      const found = model.ServedItemUserModels.find(
        i => i.ItemId === si.ItemId
      );
      return {
        ...si,
        selected: Boolean(found),
        OrderNum: isNil(found) ? null : found.OrderNum,
      };
    });
    await DB.ServedItems.bulkPut(updatedLocalServedItems);

    dispatch(success(types.SAVE_ORDER_NUM_SUCCESS, true));
  } catch (e) {
    dispatch(error(types.SAVE_ORDER_NUM_ERROR, e));
  }

  dispatch(loading(types.SAVE_ORDER_NUM_FETCHING, false));
};



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/mealTypes/state/actions.js